export const PASSWORD_RESET_SENT_MESSAGE =
  'If an account exists for that email, we sent a reset link. It often goes to spam — check there.';

export const PASSWORD_RESET_INVALID_EMAIL = 'Enter a valid email.';

export const PASSWORD_RESET_RATE_LIMIT = 'Too many attempts. Try again later.';

export const PASSWORD_RESET_RETRY = 'Couldn’t send the reset email. Try again.';

/**
 * Map a Firebase Auth error code from sendPasswordResetEmail.
 * Unknown accounts use the same confirmation as a real send.
 * @param {string | undefined} code
 * @returns {{ kind: 'sent' | 'invalid' | 'rate-limit' | 'retry', message: string }}
 */
export function passwordResetOutcome(code) {
  switch (code) {
    case 'auth/user-not-found':
      return { kind: 'sent', message: PASSWORD_RESET_SENT_MESSAGE };
    case 'auth/invalid-email':
      return { kind: 'invalid', message: PASSWORD_RESET_INVALID_EMAIL };
    case 'auth/too-many-requests':
      return { kind: 'rate-limit', message: PASSWORD_RESET_RATE_LIMIT };
    default:
      return { kind: 'retry', message: PASSWORD_RESET_RETRY };
  }
}
